

















































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbRow, mdbCol, mdbModal, mdbModalHeader, mdbModalBody, mdbModalFooter, mdbModalTitle } from '@folky-tools/mdbvue';
import { appService, notificationsService } from '@/services';
import { BusinessFrontPageSummary } from '@/models/businesses/business-front-page-summary';
import QrcodeVue from 'qrcode.vue';

@Component({
    components: {
        mdbNavbar: () => import('@folky-tools/mdbvue/src/components/Navigation/Navbar.vue'),
        mdbNavbarBrand: () => import('@folky-tools/mdbvue/src/components/Navigation/NavbarBrand.vue'),
        mdbNavItem: () => import('@folky-tools/mdbvue/src/components/Navigation/NavbarItem.vue'),
        mdbNavbarNav: () => import('@folky-tools/mdbvue/src/components/Navigation/NavbarNav.vue'),
        mdbNavbarToggler: () => import('@folky-tools/mdbvue/src/components/Navigation/NavbarCollapse.vue'),
        mdbDropdown: () => import('@folky-tools/mdbvue/src/components/Components/Dropdown.vue'),
        mdbDropdownToggle: () => import('@folky-tools/mdbvue/src/components/Components/DropdownToggle.vue'),
        mdbDropdownMenu: () => import('@folky-tools/mdbvue/src/components/Components/DropdownMenu.vue'),
        mdbDropdownItem: () => import('@folky-tools/mdbvue/src/components/Components/DropdownItem.vue'),
        mdbIcon: () => import('@folky-tools/mdbvue/src/components/Content/Fa.vue'),
        mdbBadge: () => import('@folky-tools/mdbvue/src/components/Components/Badge.vue'),
        mdbBtn,
        mdbRow,
        mdbCol,
        mdbModal,
        mdbModalHeader,
        mdbModalBody,
        mdbModalFooter,
        mdbModalTitle,
        QrcodeVue
    }
})
export default class NavbarLoggedIn extends Vue {
    @Prop(String) private readonly page!: string | undefined;
    @Prop(String) private readonly businessTradeName!: string | undefined;
    @Prop({ default: () => [] }) private readonly pageParams!: any[];
    @Prop() private openSideNav: boolean = false;
    @Prop({ type: BusinessFrontPageSummary, default: null }) private businessFrontPageSummary!: BusinessFrontPageSummary;
    @Prop() private readonly unviewedOrders!: number;
    @Prop() private readonly maxBusinessPricingLevel!: number;
    private toggle: boolean = false;
    private activePage: string | undefined = this.page;
    private showShareBusinesscardModal: boolean | null = false;

    public toggleSideNav() {
        this.toggle = !this.toggle;
        this.$parent.$emit('toggle', this.toggle);
    }

    public get computedPage() {
        return {
            activePage: this.page
        };
    }

    public get linkToMyAccount() {
        return `${process.env.VUE_APP_IDENTITY_SERVER_URL}?appClientId=${appService.getCurrentApplication().clientId}&ui_locales=${this.$i18n.locale}`;
    }

    @Watch('openSideNav')
    private onOpenSideNavChanged(newValue: boolean, oldValue: boolean) {
        this.toggle = newValue;
    }

    private linkToCanonicalConsumerBusinessFrontPage(): string | undefined {
        const canonicalPublicationStatus = this.businessFrontPageSummary ? this.businessFrontPageSummary.publicationStatus.find(ps => ps.isCanonical) : null;

        if (!canonicalPublicationStatus) {
            return undefined;
        }

        const linkToConsumerFrontPage = canonicalPublicationStatus.urlParts.some(urlPart => urlPart.culture === this.$i18n.locale)
            ? canonicalPublicationStatus.urlParts.find(urlPart => urlPart.culture === this.$i18n.locale)
            : canonicalPublicationStatus.urlParts.find(urlPart => urlPart.culture === this.$i18n.fallbackLocale);

        return canonicalPublicationStatus.isPublished && this.businessFrontPageSummary && this.businessFrontPageSummary.hasSlug ? `${linkToConsumerFrontPage!.urlForEntitiesWithSlug}/${this.businessFrontPageSummary.slug}` : undefined;
    }

    private linkToCanonicalConsumerBusinessTeaserCard(): string | undefined {
        const canonicalPublicationStatus = this.businessFrontPageSummary ? this.businessFrontPageSummary.publicationStatus.find(ps => ps.isCanonical) : null;

        if (!canonicalPublicationStatus) {
            return undefined;
        }

        const linkToConsumerFrontPage = canonicalPublicationStatus.urlParts.some(urlPart => urlPart.culture === this.$i18n.locale)
            ? canonicalPublicationStatus.urlParts.find(urlPart => urlPart.culture === this.$i18n.locale)
            : canonicalPublicationStatus.urlParts.find(urlPart => urlPart.culture === this.$i18n.fallbackLocale);

        return canonicalPublicationStatus.isPublished && this.businessFrontPageSummary && !this.businessFrontPageSummary.hasSlug ? `${linkToConsumerFrontPage!.urlForEntitiesWithoutSlug}?searchTerm=${this.businessTradeName}#top` : undefined;
    }

    private linkToCentralConsumerBusinessCardpage(): string | undefined {
        const orgCentralConsumerDetails = JSON.parse(`${process.env.VUE_APP_CENTRAL_CONSUMER_DETAILS}`);

        if (!orgCentralConsumerDetails) {
            return undefined;
        }

        const selectedConsumerLang = orgCentralConsumerDetails.url.hasOwnProperty(this.$i18n.locale) ? this.$i18n.locale.toString() : this.$i18n.fallbackLocale.toString();
        return `${orgCentralConsumerDetails.url[selectedConsumerLang]}/${orgCentralConsumerDetails.businessWord[selectedConsumerLang]}/${this.businessFrontPageSummary.slug}/${orgCentralConsumerDetails.businessCardPage[selectedConsumerLang]}`;
    }

    private goToBusinessBasicData() {
        this.showShareBusinesscardModal = false;
        this.$router.push(`/businesses/basic-data/${this.businessFrontPageSummary.businessId}?businessName=${this.businessTradeName}`);
    }
    private closeShareBusinesscardModal() {
        this.showShareBusinesscardModal = false;
    }
    private openShareBusinesscardModal() {
        this.showShareBusinesscardModal = true;
    }
    private copyToClipboard(text: string) {
        navigator.clipboard.writeText(text);

        notificationsService.showToastSuccessNotification('components.shared.navbarLoggedIn.notifications.linkSuccessfulyCopied');
    }
}
